enum PromptIcons {
    Danger = "danger",
    Warning = "warning",
    Primary = "primary",
    Info = "info"
}

export default class Prompt {
    isOpen: boolean = false
    icon: PromptIcons = PromptIcons.Danger
    title: string = ''
    message: string = ''

    shouldShowCloseButton: boolean = true
    closeButtonText: string = 'Close'
    closeButtonMethod: string | null = null

    shouldShowActionButton: boolean = false
    actionButtonText: string = 'Okay'
    actionButtonMethod: string | null = null

    shouldShowTertiaryButton: boolean = false
    tertiaryButtonText: string | null = null
    tertiaryButtonAction: string | null = null

    open (): this {
        this.isOpen = true

        return this
    }

    close (): this {
        this.isOpen = false

        return this
    }
}


// WEBPACK FOOTER //
// ./src/models/Prompt.ts